import { create } from "zustand";

/**
 * Zustand store for workspace threads state.
 * This makes workspace threads accessible globally, solving the issue where
 * SidebarDndProvider (in Main.jsx) can't access WorkspaceThreadsContext
 * (in AppSidebar) due to provider hierarchy.
 */
export const useWorkspaceThreadsStore = create((set, get) => ({
  // Map of workspace ID -> array of threads
  workspaceThreads: {},

  // Loading state
  isLoadingThreads: true,

  // Set entire workspace threads map
  setWorkspaceThreads: (threadsOrUpdater) => {
    if (typeof threadsOrUpdater === "function") {
      set((state) => ({
        workspaceThreads: threadsOrUpdater(state.workspaceThreads),
      }));
    } else {
      set({ workspaceThreads: threadsOrUpdater });
    }
  },

  // Set loading state
  setIsLoadingThreads: (isLoading) => {
    set({ isLoadingThreads: isLoading });
  },

  // Get threads for a specific workspace
  getWorkspaceThreads: (workspaceId) => {
    return get().workspaceThreads[workspaceId] || [];
  },

  // Update threads for a specific workspace
  setThreadsForWorkspace: (workspaceId, threads) => {
    set((state) => ({
      workspaceThreads: {
        ...state.workspaceThreads,
        [workspaceId]: threads,
      },
    }));
  },

  // Clear all workspace threads
  clearWorkspaceThreads: () => {
    set({ workspaceThreads: {}, isLoadingThreads: true });
  },
}));

export default useWorkspaceThreadsStore;
